import { normalizeObject, dataLayerPush } from "../shared/utils";
export function alertBarNotificationView(e) {
    var data = (e.detail || {}).data;
    var title = data.title, location = data.location;
    var notification_location = location || "";
    var notification_title = title || window.document.title;
    var notificationData = normalizeObject({
        "event": "notification_view",
        "event_action": notification_location + "_view",
        "event_category": "notifications",
        "event_label": notification_title,
        "notification_action": "notification_view",
        "notification_location": notification_location,
        "notification_title": notification_title,
        "non_interaction": true
    });
    dataLayerPush(notificationData);
}
export function alertBarClick(e) {
    var data = (e.detail || {}).data;
    var title = data.title, location = data.location, destination = data.destination, text = data.text;
    var destination_url = destination || "";
    var click_text = text || "";
    var notification_location = location || "";
    var notification_title = title || window.document.title;
    var alertBarData = normalizeObject({
        "event": "notification_click",
        "event_action": notification_location + "_click",
        "event_category": "notifications",
        "event_label": notification_title + ":" + click_text + ":" + destination_url,
        "notification_action": "notification_click",
        "notification_location": notification_location,
        "notification_title": notification_title
    });
    dataLayerPush(alertBarData);
}
